import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UIState {
  isTemplateEditorOpen: boolean;
  templateEditorMode?: 'email' | 'text';
  templateEditorTitle?: string;
}

const initialState: UIState = {
  isTemplateEditorOpen: false,
  templateEditorMode: undefined,
  templateEditorTitle: undefined,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setTemplateEditorOpen: (state, action: PayloadAction<{
      isOpen: boolean;
      mode?: 'email' | 'text';
      title?: string;
    }>) => {
      state.isTemplateEditorOpen = action.payload.isOpen;
      state.templateEditorMode = action.payload.mode;
      state.templateEditorTitle = action.payload.title;
    },
    closeTemplateEditor: (state) => {
      state.isTemplateEditorOpen = false;
      state.templateEditorMode = undefined;
      state.templateEditorTitle = undefined;
    },
  },
});

export const { setTemplateEditorOpen, closeTemplateEditor } = uiSlice.actions;
export default uiSlice.reducer;
